module.exports = __webpack_public_path__ + "static/salesforce-95993c4ade30df59e7ba49b8ff05feb9.png";